import styled from '@emotion/styled';
import { Select } from 'antd';

const AddSelector = styled(Select)`
  height: 40px;

  .ant-select-selector {
    height: 40px !important;
    font-size: 16px;
    align-items: center;
  }
`;

export default AddSelector;